import { ReactComponent as FullStar } from "../../static/images/full_star.svg";
import { ReactComponent as HalfStar } from "../../static/images/half_star.svg";
import { ReactComponent as BlankStar } from "../../static/images/blank_star.svg";

const StarRating = ({ rating }) => {
  const roundedRating = Math.round(rating * 2) / 2;
  const fullStars = Math.floor(roundedRating);

  const hasHalfStar = roundedRating % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div>
      {Array(fullStars)
        .fill()
        .map((_, i) => (
          <FullStar key={`full-${i}`} />
        ))}
      {hasHalfStar && <HalfStar key={"half"} />}
      {Array(emptyStars)
        .fill()
        .map((_, i) => (
          <BlankStar key={`empty-${i}`} />
        ))}
    </div>
  );
};

export default StarRating;
